import React from "react";
import { Col, Row, Button, Container } from "react-bootstrap";
import { useRouter } from "next/router";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";
import LoginModal from "../components/auth/LoginModal";
import Icons from "../components/icons";

const IndexPage = ({ state }) => {
  const router = useRouter();
  return (
    <Layout
      title="Raise Startup Capital"
      invertNav
      meta={{
        card: "summary_large_image",
        description:
          "Raise capital with us and benefit from our over 30 years of experience and expertise in investing in startups and scaleups.",
      }}
      state={state}
    >
      <div className="bg5 header-content">
        <Container>
          <Row className="content">
            <Col className="hero-padding">
              <h1 className="hero-in-title">
                Raise capital, unlock potential,
                <br /> and accelerate growth
              </h1>
              <div className="container-button-wrapper m-md-0 m-4">
                <Button
                  onClick={() =>
                    state.user.id
                      ? router.push("/submit")
                      : LoginModal.show("/submit")
                  }
                  className="invest-button button-hero"
                  variant="light"
                >
                  Start your Application
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="section-raise">
        <Container>
          <Row className="mt-4 mb-4">
            <Col lg={6} md={12} className="order-xs-2 order-lg-1">
              <div className="wrap-img">
                <img className="img-fluid" src="/static/raice/investor.jpg" />
              </div>
            </Col>
            <Col lg={6} md={12} className="order-xs-1 order-lg-2">
              <div className="wrap-ctr">
                <h2 className="mb-2">Unlocking value, tailored for success</h2>
                <div className="para-to-bt pgraise">
                  <p>
                    At Stride Equity, we understand that every startup has
                    unique funding needs. We offer a variety of digital capital
                    raising solutions, including public or private Crowdsourced
                    Funding (CSF) and Wholesale Offers. We connect founders with
                    investors who understand and support their vision. We don’t
                    chase hype or inflate valuations. Our focus is on building
                    long-term value for all stakeholders – founders and
                    investors alike.
                  </p>
                  <p className="pb-0 mb-0">
                    This goes beyond simply unlocking capital. Being a Stride
                    Equity Enabled company means gaining access to relevant
                    expertise, experience and extensive networks. We invest our
                    time and resources to understand your business and tailor a
                    capital raising strategy that fuels your growth and
                    financial success to deliver results for founders and
                    investors.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="mt-md-4 mt-3 mb-md-2 mb-3">
            <Col lg={6} md={12} className="order-2 order-lg-1">
              <div className="wrap-cl">
                <h2 className="mb-5">
                  Connecting founders and investors for impactful growth
                </h2>
                <p className="wrap-cl para-to-bt pgraise">
                  At Stride Equity, we cultivate a community of emerging and
                  experienced investors and invite them to participate in the
                  journey of our portfolio companies. We leverage our resources,
                  expertise, and extensive networks to support our investee
                  companies’ growth and increase their chances of success. We
                  focus on collaborating with exceptional founders dedicated to
                  making a genuine impact through their businesses.
                </p>
              </div>
            </Col>
            <Col lg={6} md={12} className="order-1 order-lg-2">
              <div className="wrap-img">
                <img className="img-fluid" src="/static/raice/invest.jpg" />
              </div>
            </Col>
          </Row>

          <Row className="mt-2 repeat r-how-it-works">
            <Col md={12}>
              <hr className="how-it" />
              <h5 className="text-center m-0">How it works</h5>
              <hr className="how-it" />
              <div className="section-how-it-works">
                <div className="wrap-detail">
                  <h1 className="number">01.</h1>
                  <h3 className="text">Prepare your business</h3>
                </div>
                <div className="wrap-detail">
                  <h1 className="number">02.</h1>
                  <h3 className="text">Apply</h3>
                </div>
                <div className="wrap-detail">
                  <h1 className="number">03.</h1>
                  <h3 className="text">Due diligence</h3>
                </div>
                <div className="wrap-detail">
                  <h1 className="number">04.</h1>
                  <h3 className="text">Agreements</h3>
                </div>
                <div className="wrap-detail">
                  <h1 className="number">05.</h1>
                  <h3 className="text">Funding campaign</h3>
                </div>
              </div>
            </Col>
          </Row>
          <hr className="how-it" />
          <Row className="mt-4 mb-4 w-can-apply ml-0 mr-0  ">
            <Col md={6} className="p-0">
              <h2 className="mb-5">Who can apply?</h2>
            </Col>
            <Col md={6} className="p-0">
              <h5 className="adjust-space">
                <Icons.Reck />{" "}
                <span>You are a founder of an Australian company</span>{" "}
              </h5>
              <h5>
                <Icons.Reck /> <span>Seek minimum funding of $400,000</span>{" "}
              </h5>
              <h5>
                <Icons.Reck /> <span>Have a business plan</span>{" "}
              </h5>
              <h5 className="mb-5">
                <Icons.Reck />{" "}
                <span>
                  Have the qualities and drive to make your business a success
                </span>{" "}
              </h5>
              <Button
                onClick={() =>
                  state.user.id
                    ? router.push("/submit")
                    : LoginModal.show("/submit")
                }
                size="lg"
                variant="outline-primary"
              >
                Start your application
              </Button>
            </Col>
          </Row>
          {/* <hr className='how-it'/> */}
        </Container>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res }) {
  return {
    props: {
      state: await ServerProps.getState(req),
    },
  };
}

export default IndexPage;
